import { library } from "@fortawesome/fontawesome-svg-core"

// O pacote solid (fas) permanece completo pois há ícones dinâmicos vindos da API
// (ex: promotion.icon em BenefitFinder) que podem referenciar qualquer ícone.
// Dos pacotes regular (far) e brands (fab) só usamos estes — importar os pacotes
// inteiros custava ~600KB no bundle principal.
import { fas } from "@fortawesome/free-solid-svg-icons"
import { faTimesCircle } from "@fortawesome/free-regular-svg-icons"
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons"

library.add(fas, faTimesCircle, faWhatsapp)
